import { useCallback, useEffect, useState } from "react";

import {
  loadNormalizeEnabled,
  loadSchedulePrefs,
  sanitizeSchedulePrefs,
  saveNormalizeEnabled,
  saveSchedulePrefs,
  type TaskCalendarSchedulePrefs,
} from "~ui/templates/TaskCalendarTemplate/taskCalendarNormalize";

export function useTaskCalendarSchedule() {
  const [normalizeEnabled, setNormalizeEnabledState] = useState(loadNormalizeEnabled);
  const [schedulePrefs, setSchedulePrefsState] = useState(loadSchedulePrefs);

  useEffect(() => {
    saveNormalizeEnabled(normalizeEnabled);
  }, [normalizeEnabled]);

  useEffect(() => {
    saveSchedulePrefs(schedulePrefs);
  }, [schedulePrefs]);

  const setNormalizeEnabled = useCallback((value: boolean) => {
    setNormalizeEnabledState(value);
  }, []);

  const setSchedulePrefs = useCallback((value: TaskCalendarSchedulePrefs) => {
    setSchedulePrefsState(sanitizeSchedulePrefs(value));
  }, []);

  return {
    normalizeEnabled,
    schedulePrefs,
    setNormalizeEnabled,
    setSchedulePrefs,
  };
}
